var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedUsers.length > 1)?_c('div',{staticClass:"evaluatee-carousel mb-3"},[_vm._m(0),_c('EvaluateeCarousel',{attrs:{"current_users":_vm.selectedUsers,"actualTest":_vm.test,"sticky":false},on:{"student_selcted":_vm.slotStudentSelected}})],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"current-evaluatee-label"},[_c('strong',[_vm._v(" Actualmente evaluando a: ")])])
}]

export { render, staticRenderFns }